import { isNil } from 'ramda';

import { IntNumber } from './NumberTypes/IntNumber';

export class ActivePower {
  private constructor(
    private value: IntNumber,
    private unit: 'W' | 'kW' = 'W'
  ) {
    this.value = value;
    this.unit = unit;
  }

  static fromWattNumber(value?: number) {
    return new ActivePower(IntNumber.fromNumber(value));
  }

  addTo(other: ActivePower) {
    const thisActivePowerWatt = this.toWatt();
    const otherAcactivePowerWatt = other.toWatt();
    const reactivePowerSum = ActivePower.fromWattNumber(
      thisActivePowerWatt.value.addTo(otherAcactivePowerWatt.value)
    );

    return reactivePowerSum;
  }

  toKilo() {
    if (this.unit !== 'kW') {
      const currentValue = this.value.toNumber();
      if (isNil(currentValue))
        return new ActivePower(IntNumber.fromNumber(currentValue), 'kW');

      return new ActivePower(IntNumber.fromNumber(currentValue / 1000), 'kW');
    }
    return this;
  }

  toWatt() {
    if (this.unit === 'kW') {
      const currentValue = this.value.toNumber();
      if (isNil(currentValue))
        return new ActivePower(IntNumber.fromNumber(currentValue), 'W');

      return new ActivePower(IntNumber.fromNumber(currentValue * 1000), 'W');
    }
    return this;
  }

  toString() {
    const value = this.value.toFixedNumber();

    return !isNil(value) ? `${value} ${this.unit}` : 'N/A';
  }
}
